import gql from 'graphql-tag';

export const DELETE_ARTICLE_CATEGORY_MUTATION = gql`
  mutation DeleteArticleCategoryMutation($id: ID!) {
    deleteArticleCategory(id: $id) {
      id
      errors
    }
  }
`;
